<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" persistent max-width="450px">
    <v-card>
      <v-card-title class="text-h5">{{ title || 'Confirm Action' }}</v-card-title>
      <v-card-text>
        <p>{{ message || 'Are you sure you want to proceed?' }}</p>
        <p v-if="itemName && itemType" class="mt-2">
          You are about to delete the {{ itemType }} named: <strong>{{ itemName }}</strong>.
        </p>
        <p v-if="warningMessage" class="mt-3 font-weight-bold text-warning">
          {{ warningMessage }}
        </p>
        <p class="mt-2">This action cannot be undone.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" variant="text" @click="$emit('cancel')">Cancel</v-btn>
        <v-btn color="error darken-1" variant="text" @click="$emit('confirm')" :loading="loading">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    modelValue: Boolean,
    title: String,
    message: String,
    itemName: String,
    itemType: String,
    loading: Boolean,
    warningMessage: String,
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
})
export default class ConfirmationDialog extends Vue {
  modelValue!: boolean;
  title!: string;
  message!: string;
  itemName!: string;
  itemType!: string;
  loading!: boolean;
  warningMessage!: string;
}
</script>
